import React, { Component } from "react";
import "../../../../assets/sass/_common.scss";
import { notificationAction } from "../../../../redux/reducers/notification_reducer";
import { Message } from "../../../../utils/messages.js";
import { connect } from "react-redux";
import { addSection } from "../apiCalls";
import SectionForm from "./Form/SectionForm";
class AddSection extends Component {
  state = {
    sid: 0,
    selectedSectionInfo: {
      name: "",
    },

    validateSection: {},
  };

  handleFormFieldChange = (e) => {
    const { name, value } = e.target;
    if (
      name === "name"

    ) {
      this.validateField({ name, value });
      return;
    }

  };

  validateField = ({ name, value }) => {

    const { selectedSectionInfo, validateSection } = this.state;
    if (name === "name"
    ) {
      this.setState({
        selectedSectionInfo: {
          ...selectedSectionInfo,
          // [`invalid${name}`]: !value,
          [name]: value,
        },
        validateSection: {
          ...validateSection,
          [`invalid${name}`]: !value,
          // [name]: value,
        },
      })
    }
  }
  handleSaveSection = () => {

    let { selectedSectionInfo, validateSection } = this.state;

    if (!selectedSectionInfo.name) {
      this.setState({
        validateSection: {
          ...validateSection,
          invalidname: true,
        },
      });
      const info = {
        message: Message.AddSection,
        status: "error",
      };
      this.props.notificationAction(info);
      return;
    }
    this.setState({
      Loading: true,
    });

    addSection({ name: selectedSectionInfo })
      .then((response) => {
        if (response.code == 200) {
          const info = {
            message: Message.AddSuccess,
            status: "success",
          };
          this.props.notificationAction(info);
          this.props.history.push("/lookups/section");
          return;
        } else if (response.code != 200) {
          const info = {
            message: response.message,
            status: "error",
          };
          this.props.notificationAction(info);
          return;
        }
      })
      .catch((error) => {
        const info = {
          message: Message.AddFailure,
          status: "error",
        };
        this.props.notificationAction(info);
      });
  };


  render() {
    return (
      <>
        <SectionForm
          selectedSectionInfo={this.state.selectedSectionInfo}
          onFormFieldChange={this.handleFormFieldChange}
          validateSection={this.state.validateSection}
          onSave={this.handleSaveSection}
        />
      </>
    )
  }

}
const actions = (dispatch) => ({
  notificationAction: (message, status) =>
    dispatch(notificationAction(message, status)),
});


export default connect(null, actions)(AddSection);
